export default __webpack_public_path__ + "static/media/nft.1a24490f.png";